import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { message, Upload, } from 'antd';

import styles from './index.module.css'
import { actionCreators } from '../../store';
import addIcon from '../../../../statics/components_list_add_icon.png'


function UploadDragImage({fileList, setFileList, imagePreview, setImagePreview}) {
    // const [fileList, setFileList] = useState([]);
    // const [imagePreview, setImagePreview] = useState(null);

    const handleUploadChange = info => {
        console.log("info = ", info);
        // 更新文件列表，只保留最后一个文件
        setFileList(info.fileList.slice(-1));
    }

    const beforeUpload = file => {
        // 检查文件格式
        const isSupportedFormat = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/webp', 'image/tiff', 'image/x-portable-pixmap'].includes(file.type);
        if (!isSupportedFormat) {
            message.error('只支持 jpg、png、jpeg、bmp、gif、webp、tiff、tif、ppm 格式');
            setImagePreview(null)
            setFileList([])
            return Upload.LIST_IGNORE;
        }

        // 检查文件大小
        const isLt4M = file.size / 1024 / 1024 < 4;
        if (!isLt4M) {
            message.error('图片必须小于4MB!');
            setImagePreview(null)
            setFileList([])
            return Upload.LIST_IGNORE;
        }

        // 检查图片尺寸
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = e => {
                const img = new Image()

                img.onload = () => {
                    const { width, height } = img;
                    if (width >= 100 && width <= 4096 && height >= 100 && height <= 4096) {
                        console.log("验证成功");
                        resolve(); // 图片尺寸符合要求

                        // 生成图片预览
                        setImagePreview(e.target.result);
                    } else {
                        console.log("图片尺寸须在 100px 到 4096px 之间");
                        message.error('图片尺寸须在 100px 到 4096px 之间');
                        setImagePreview(null)
                        setFileList([])
                        reject(); // 图片尺寸不符合要求
                    }
                }

                img.src = e.target.result
            }

            reader.readAsDataURL(file)
        }).then(() => {
            return false
        }).catch(() => {
            return false
        })
    }

    return (
        <Upload.Dragger
            fileList={fileList}
            showUploadList={false}
            onChange={handleUploadChange}
            beforeUpload={beforeUpload}
            className={styles.custome_upload}
        >
            {imagePreview ? (
                <img src={imagePreview} alt="icon" className={styles.image_preview} />
            ) : (
                <>
                    <img src={addIcon} alt="add icon" className={styles.add_img} />
                    <p className={styles.upload_text}>点击或者拖动图片到这里上传</p>
                    <p className={styles.min_text}>最多支持 4MB 大小图片，当前仅支持 jpg、png、jpeg、bmp、gif、webp、tiff、tif、ppm 格式</p>
                    <p className={styles.min_text}>图片尺寸须 &gt;= 100px, &lt;=4096px</p>
                </>
            )}
        </Upload.Dragger>
    )
}

export default UploadDragImage